import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/master';
import * as api from '../services/api';
import { load, loaded } from '../ducks/loading';
//import { toast } from 'react-toastify';

function* getThemeData(action) {
  try {
    yield put(load());
    const res = yield call(api.GET, '/master/getThemeData', action.data);
    if (res.status == 'success') {
      yield put(actions.getThemeDataSuccess(res.data));
    } else {
      yield put(actions.getThemeDataError(true));
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.getThemeDataError(true));
    yield put(loaded());
  }
}

function* getWidgetMstData() {
  try {
    yield put(load());
    const res = yield call(api.GET, '/master/getWidgetMstData');
    if (res.status == 'success') {
      yield put(actions.getWidgetMstDataSuccess(res.data));
    } else {
      yield put(actions.getWidgetMstDataError(true));
    }
    yield put(loaded());
  } catch (error) {
    yield put(actions.getWidgetMstDataError(true));
    yield put(loaded());
  }
}

export function* watch() {
  yield takeEvery(actions.GET_THEME_DATA, getThemeData);
  yield takeEvery(actions.GET_WIDGET_MST_DATA, getWidgetMstData);

}

export default function* rootSaga() {
  yield [
    fork(watch),
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/master.js